<template>
  <div>
    <div :class="$style['edittag']" v-if="!openButtons">
      <mds-icon name="pencil" size="small" @click.native="EditData()" />
    </div>

    <div v-if="showButton && openButtons" :style="'display: flex;' + divstyle">
      <div>
        <adl-input-format
          :isDisabled="false"
          :value="value"
          v-model="value"
          :currencyFormat="currencyFormat"
          appendText=""
          :microcopyBelow="microcopyBelow"
          :maxlength="maxlength"
          :maxvalue="maxvalue"
          :isAllowOnlyNumber="isAllowOnlyNumber"
          :AllowOnlyDecimalTill="AllowOnlyDecimalTill"
          label=""
          microcopyBelow=""
        ></adl-input-format>
      </div>
      <div v-if="ShowEditTextBox">
        <mds-button variation="flat" @click="CancelValue()">
          {{ cancelText }}
        </mds-button>
        <mds-button
          variation="flat"
          style="color: #006fba"
          @click="SaveValue()"
        >
          {{ saveText }}
        </mds-button>
      </div>
    </div>
  </div>
</template>
<script>
import AdlInputFormat from "../input-format/InputFormat.vue";
import { MdsButton } from "@mds/button";
import MdsIcon from "@mds/icon";
export default {
  inheritAttrs: false,

  props: {
    divstyle: {
      type: String,
    },
    value: {
      type: String,
    },
    cancelText: {
      type: String,
    },
    saveText: {
      type: String,
    },
    isAllowOnlyNumber: {
      type: Boolean,
    },
    AllowOnlyDecimalTill: {
      type: Number,
    },
    currencyFormat: {
      type: String,
    },
    errorText: {
      type: Array,
    },
    isError: {
      type: Boolean,
    },
    maxlength: {
      type: Number,
      default: 10,
    },
    maxvalue: {
      type: Number,
      default: 0,
    },
    minvalue: {
      type: Number,
      default: 0,
    },
    microcopyBelow: {
      type: String,
    },
    ShowEditTextBox: {
      type: Boolean,
      default: true,
    },
    openButtons: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    AdlInputFormat,
    MdsButton,
    MdsIcon,
  },

  data() {
    return {
      isFocus: false,
      refreshKey: 0,
      showButton: false,
    };
  },
  computed: {},

  async created() {},
  methods: {
    SaveValue() {
      this.showButton = false;
      this.$emit("change", this.value);
    },
    CancelValue() {
      this.showButton = false;
      this.$emit("cancel");
    },
    EditData() {
      if (this.ShowEditTextBox) {
        if (!this.openButtons) {
          this.showButton = true;
        } else this.showButton = !this.showButton;
      }
      this.$emit("Edit", this.showButton);
    },
  },
};
</script>
<style lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";

.adl-input {
  .edittag {
    display: none;
  }
  .label {
    @include mds-body-text-m();
    margin-bottom: $mds-space-1-and-a-half-x;
  }

  .charcount {
    @include mds-body-text-s();
  }

  .mds-microcopy {
    margin-top: 8px;
  }
}
</style>
